exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "advertisement-form .ui-fluid .ui-button-text-icon-left .ui-button-text {\n  padding-left: 2em; }\n\nadvertisement-form .ui-fluid .button-panel {\n  text-align: center; }\n  advertisement-form .ui-fluid .button-panel button {\n    width: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/advertisement-form/advertisement-form.component.scss
// module id = ../../../../../src/app/component-module/advertisement-form/advertisement-form.component.scss
// module chunks = main